import * as React from 'react';
import { useSelector } from 'react-redux';

import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useIsDesktop } from '@cian/valuation-utils-component';

import { ObjectInfo } from '../../components/ObjectInfo/ObjectInfo';
import { selectFilters } from '../../selectors/filters';
import { useGetObjectInfoTitle } from './utils';
import { getEstimationFiltersHash, selectEstimationByDealType } from '../../selectors/estimation';
import { selectAddressText } from '../../selectors/estimation/selectAddressText';
import { TRefWrapper } from '../Scrolling';
import { StatusLabel } from '../Status';
import { selectDealType, selectIsMyHome } from '../../selectors/page';
import { MyHomeWithoutEstimation } from '../../components/MyHomeWithoutEstimation';
import { trackMyHomeWithoutEstimationShow } from './tracking';

interface IObjectInfoContainerProps {
  refWrapper: TRefWrapper;
}

export function ObjectInfoContainer({ refWrapper }: IObjectInfoContainerProps) {
  const { address: addressFromStore } = useSelector(selectFilters);
  const isDesktop = useIsDesktop();
  const dealType = useSelector(selectDealType);
  const estimation = useSelector(selectEstimationByDealType(dealType));
  const isMyHome = useSelector(selectIsMyHome);
  const { mobileAddress, desktopAddress } = useSelector(selectAddressText);
  const hashEstimation = useSelector(getEstimationFiltersHash);
  const _objectInfoTitle = useGetObjectInfoTitle();
  // oxlint-disable-next-line react/exhaustive-deps
  const objectInfoTitle = React.useMemo(() => _objectInfoTitle, [hashEstimation]);
  // oxlint-disable-next-line react/exhaustive-deps
  const address = React.useMemo(() => {
    if (isDesktop && desktopAddress) {
      return desktopAddress;
    }

    return mobileAddress ? mobileAddress : addressFromStore;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hashEstimation]);

  return refWrapper(
    <ObjectInfo
      estimationBanner={
        !estimation.data &&
        isMyHome && (
          <ActionAfterViewObserver callback={trackMyHomeWithoutEstimationShow}>
            <MyHomeWithoutEstimation />
          </ActionAfterViewObserver>
        )
      }
      statusLabel={<StatusLabel />}
      isDesktop={isDesktop}
      title={objectInfoTitle}
      address={address}
    />,
  );
}
